<article class="sen-blue-bg h-100 w-100" fxLayout="row">
    <section class="overflow-hidden bg-white" fxFlex="1 1 auto">
        <router-outlet></router-outlet>
    </section>
    <sen-app-main-menu-bar></sen-app-main-menu-bar>
</article>
<sen-app-header-info></sen-app-header-info>
<sen-app-user-info></sen-app-user-info>
<sen-app-copyright-info></sen-app-copyright-info>